module.exports = require('./helpers/bundle-url').getBundleURL('473Ps') + "logo-dark.eefe0b7f.svg";